export interface SpecialArticle {
  id: string;
  title: string;
  author: string;
  date: string;
  excerpt: string;
}

export interface Special {
  id: string;
  title: string;
  intro: string;
  cover: string;
  group: string;
  dramaIds: string[];
  articles: SpecialArticle[];
}

export const specials: Special[] = [
  {
    id: "s1",
    title: "经典情感纠葛剧：那些让人不敢快进的婚姻时刻",
    intro:
      "我们从网站收录的作品里，挑选出最懂‘关系的裂缝’的几部剧集，聊聊它们如何用克制的镜头，拍出婚姻里最真实的紧绷。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20collage%20mood%20of%20dim%20elegant%20interiors%20with%20amber%20and%20crimson%20light%2C%20emotional%20tv%20drama%20atmosphere%2C%20no%20text&width=1600&height=900&seq=chu-gui-special-01&orientation=landscape",
    group: "剧集策划",
    dramaIds: ["d1", "d3", "d11"],
    articles: [
      { id: "s1a1", title: "从《出轨的妻子》看怀疑如何吞掉一段婚姻", author: "沈砚", date: "2024-09-18", excerpt: "怀疑一旦成为习惯，家就变成了牢笼。" },
      { id: "s1a2", title: "《婚姻的裂缝》：把婚姻危机拍成日常的勇气", author: "苏迟", date: "2024-07-22", excerpt: "它不狗血，却比狗血更让人窒息。" },
      { id: "s1a3", title: "《围城之下》群像叙事的得与失", author: "陆知微", date: "2024-10-06", excerpt: "三个家庭，照见婚姻的不同阶段。" },
    ],
  },
  {
    id: "s2",
    title: "悬疑与情感：当背叛成为一场罗生门",
    intro:
      "同一件事，不同的人给出不同的版本。这个专题聚焦那些把情感与悬疑编织在一起的作品，看看导演如何让观众也陷入猜忌。",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20noir%20city%20night%20with%20warm%20amber%20window%20lights%20and%20crimson%20reflections%2C%20mysterious%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=chu-gui-special-02&orientation=landscape",
    group: "类型研究",
    dramaIds: ["d2", "d6", "d7"],
    articles: [
      { id: "s2a1", title: "叙事迷宫：《她背叛的那一夜》的三种真相", author: "陆知微", date: "2024-08-30", excerpt: "出口不通向真相，而通向我们愿意相信的自己。" },
      { id: "s2a2", title: "谁才是《第三个人》？一次冷静的关系解剖", author: "黎野", date: "2024-05-09", excerpt: "故事里没有无辜者。" },
      { id: "s2a3", title: "《午夜来电》：信任的第一个缺口", author: "方楠", date: "2024-03-11", excerpt: "一通电话，撕开一个家庭。" },
    ],
  },
  {
    id: "s3",
    title: "她的选择：女性视角下的婚姻与自我",
    intro:
      "这一组成员作品把镜头交给女性角色，讲述她们如何在妻子、母亲、职员的身份之外，重新找到属于自己的名字。",
    cover:
      "https://readdy.ai/api/search-image?query=Sunlit%20modern%20interior%20with%20a%20woman%20silhouette%20by%20a%20window%2C%20warm%20amber%20and%20cream%20tones%2C%20hopeful%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=chu-gui-special-03&orientation=landscape",
    group: "主题解读",
    dramaIds: ["d5", "d8", "d10"],
    articles: [
      { id: "s3a1", title: "如果当初：《回不去的从前》与成年人的选择题", author: "温故", date: "2024-10-02", excerpt: "带着后悔，继续往前走。" },
      { id: "s3a2", title: "《原谅的边缘》：原谅不是一次决定，而是一段路", author: "沈知白", date: "2024-09-12", excerpt: "漫长而笨拙的修复过程。" },
      { id: "s3a3", title: "《她的秘密》：为自己活一次", author: "顾南", date: "2024-09-05", excerpt: "一个女人终于为自己的人生做主。" },
    ],
  },
  {
    id: "s4",
    title: "家族与往事：藏在婚戒背后的旧账",
    intro:
      "有些婚姻从一开始就被写进了别人的剧本。这个专题关注那些把家族恩怨与个人情感交织的作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Luxurious%20dim%20family%20mansion%20hall%20with%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text&width=1600&height=900&seq=chu-gui-special-04&orientation=landscape",
    group: "剧集策划",
    dramaIds: ["d9", "d12", "d4"],
    articles: [
      { id: "s4a1", title: "《红色婚戒》：当爱情被写进家族的账本", author: "何砚", date: "2024-04-20", excerpt: "爱一个人，和被安排去爱一个人，是两件事。" },
      { id: "s4a2", title: "《二次告别》：学会完整地告别一个人", author: "宋既明", date: "2024-02-28", excerpt: "不是重燃，而是真正放下。" },
      { id: "s4a3", title: "沉默的台词：《沉默的裂痕》里没说出口的一切", author: "白舟", date: "2024-06-15", excerpt: "最痛的，往往是安静。" },
    ],
  },
];